import React from 'react';

import { morefilterItems } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramCriticalAnalysis/utils';
import { Select } from 'components/DesignSystem/Select';
import { InputOption } from 'components/DesignSystem/Select/components/InputOption/InputOption';
import { ValueContainer } from 'components/DesignSystem/Select/components/ValueContainer/ValueContainer';
import { Switch } from 'components/DesignSystem/Switch';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import classes from 'components/widgets/ActivitiesTable/components/LogicCheckerFilters/ActivitiesTableFilters.module.scss';

export const statusOptions: ISelectOption<string>[] = [
    {
        value: 'To Do',
        label: 'To Do',
    },
    {
        value: 'In Progress',
        label: 'In Progress',
    },
    {
        value: 'Done',
        label: 'Done',
    },
];

export interface IsTypeFilterProps {
    typeFilterArr: ISelectOption<string>[];
    item: { lateFinish: number; lateStart: number; durationOverrun: number; activityType: string };
}
export const isTypeFilter = ({ typeFilterArr, item }: IsTypeFilterProps) => {
    const isAllTypes = typeFilterArr.map((type) => {
        switch (type.value) {
            case 'Late Finish Date':
                return item.lateFinish > 0;
            case 'Late Start Date':
                return item.lateStart > 0;
            case 'Overrun Duration':
                return item.durationOverrun > 0;
            case 'Milestones':
                return ['START_MILESTONE', 'FINISH_MILESTONE', 'Milestone'].includes(item.activityType);
            default:
                return false;
        }
    });

    return isAllTypes.every((item) => item);
};

export const ActivitiesTableFilters = ({
    search,
    setSearch,
    setOnSearch,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
    handleCriticalPath,
    isCriticalPath,
}) => {
    const handleSearch = (e) => {
        setSearch(e.target.value);
    };

    const handleClearSearch = () => {
        setSearch('');
        setOnSearch('');
    };

    const handleOnSearch = () => {
        setOnSearch(search);
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch();
        }
    };

    return (
        <div className={classes.filters}>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>Name</div>
                <div className={classes.filterTextSearch}>
                    <TextInput
                        placeholder={'Search Activities by Name'}
                        id={'filter-text-search'}
                        value={search}
                        onChange={handleSearch}
                        onClear={handleClearSearch}
                        maxLength={200}
                        onKeyDown={onKeyDown}
                        className={classes.textInput}
                        searchable={true}
                        onSearch={handleOnSearch}
                    />
                </div>
            </div>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>Status</div>
                <Select<ISelectOption<string>, true>
                    value={statusFilter}
                    options={statusOptions}
                    onChange={(value) => setStatusFilter(value)}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Status...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
            <div>
                <Switch
                    onChange={handleCriticalPath}
                    checked={isCriticalPath}
                    label={' Critical Path Only'}
                    labelPlacement={'start'}
                />
            </div>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>More Filters</div>
                <Select<ISelectOption<string>, true>
                    value={typeFilter}
                    options={morefilterItems}
                    onChange={(value) => setTypeFilter(value)}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select More Filters...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
        </div>
    );
};
